import ARCliente from '../../views/cliente/Index.vue';
import ARCMeusDados from '../../views/cliente/MeusDados.vue';
import ARCSolicitados from '../../views/cliente/Solicitados.vue';
import ARCRespondidas from '../../views/cliente/Respondidas.vue';
import ARCAprovadas from '../../views/cliente/Aprovadas.vue';
import ARCAguardando from '../../views/cliente/Aguardando.vue';
import ARCAguardandoPagamento from '../../views/cliente/AguardandoPagamento.vue';
import ARCFinalizadas from '../../views/cliente/Finalizadas.vue';
import ARCRejeitadasPU from '../../views/cliente/RejeitadasPU.vue';
import ARCRejeitadasPL from '../../views/cliente/RejeitadasPL.vue';
import ARCCotacao from '../../views/cliente/Cotacao.vue';
import ARCRespondida from '../../views/cliente/CotacaoResposta.vue';
import ARCAprovada from '../../views/cliente/CotacaoAprovada.vue';
import ARCAguardandoLojista from '../../views/cliente/CotacaoAguardando.vue';
import ARCAguardandoPagamentoPendente from '../../views/cliente/CotacaoAguardandoPagamento.vue';
import ARCFinalizada from '../../views/cliente/CotacaoFinalizada.vue';
import ARCRejeitada from '../../views/cliente/CotacaoRejeitada.vue';
import ARCCheckout from '../../views/cliente/Pagamento.vue';
import ARCCheckoutPix from '../../views/cliente/qrcodepix.vue';
import ARCCheckoutPixCancel from '../../views/cliente/qrcodepixCancel.vue';
import ARCCheckoutCC from '../../views/cliente/CartaoDeCredito.vue';
import ARCCheckoutCCancel from '../../views/cliente/CartaoDeCreditoCancel.vue';
import ARCCheckoutBB from '../../views/cliente/boleto.vue';
import ARCCheckoutBBCancel from '../../views/cliente/boletoCancel.vue';

import UserTypes from '../../enums/UserTypes';

export default [
  {
    path: '/area-restrita/cliente',
    name: 'cliente',
    component: ARCliente,
    children: [
      {
        path: '/area-restrita/cliente/meus-dados',
        name: 'cliente-meus-dados',
        component: ARCMeusDados,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/solicitados/',
        name: 'cliente-solicitados',
        component: ARCSolicitados,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/respondidas/',
        name: 'cliente-respondidas',
        component: ARCRespondidas,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/aprovadas/',
        name: 'cliente-aprovadas',
        component: ARCAprovadas,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/aguardando-pagamento/',
        name: 'cliente-aguardando-pagamento',
        component: ARCAguardandoPagamento,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/aguardando/',
        name: 'cliente-aguardando',
        component: ARCAguardando,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/finalizadas/',
        name: 'cliente-finalizadas',
        component: ARCFinalizadas,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/rejeitadas-por-usuario/',
        name: 'cliente-rejeitadas-pelo-usuario',
        component: ARCRejeitadasPU,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/rejeitadas-por-lojistas/',
        name: 'cliente-rejeitadas-pelos-lojistas',
        component: ARCRejeitadasPL,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/cotacao/:id',
        name: 'cliente-cotacao',
        props: true,
        component: ARCCotacao,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/cotacao-respondida/:id/:identifier',
        name: 'cliente-cotacao-respondida',
        props: true,
        component: ARCRespondida,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/cotacao-aprovada/:id',
        name: 'cliente-cotacao-aprovada',
        props: true,
        component: ARCAprovada,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/cotacao-aguardando/:id',
        name: 'cliente-cotacao-aguardando-aprovacao',
        props: true,
        component: ARCAguardandoLojista,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/cotacao-aguardando-pagamento/:id',
        name: 'cliente-cotacao-aguardando-aprovacao-pagamento',
        props: true,
        component: ARCAguardandoPagamentoPendente,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/cotacao-finalizada/:id',
        name: 'cliente-cotacao-finalizada',
        props: true,
        component: ARCFinalizada,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/cotacao-rejeitada/:cot_id/:usu_id/:tipo',
        name: 'cliente-cotacao-rejeitada',
        props: true,
        component: ARCRejeitada,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/cotacao/:id/pagamento/',
        name: 'cliente-cotacao-pagamento',
        props: true,
        component: ARCCheckout,
        meta: { userType: UserTypes.CLIENT },
      },
      {
        path: '/area-restrita/cliente/cotacao/:id/pix/:id_shop',
        name: 'cliente-cotacao-pagamento-pix',
        props: true,
        component: ARCCheckoutPix,
        meta: { userType: UserTypes.CLIENT }
      },
      {
        path: '/area-restrita/cotacao/:id/pix/cacelamento',
        name: 'cliente-cotacao-pagamento-pix-cancel',
        props: true,
        component: ARCCheckoutPixCancel
      },
      {
        path: '/area-restrita/cliente/cotacao/:id/cc/:id_shop/:cot_id',
        name: 'cliente-cotacao-pagamento-cc',
        component: ARCCheckoutCC,
        props: true,
        meta: { userType: UserTypes.CLIENT }
      },
      {
        path: '/area-restrita/cotacao/:id/cancelamento',
        name: 'cliente-cotacao-pagamento-ccancel',
        component: ARCCheckoutCCancel,
        props: true
      },
      {
        path: '/area-restrita/cliente/cotacao/:id/bb/:id_shop',
        name: 'cliente-cotacao-pagamento-bb',
        component: ARCCheckoutBB,
        props: true,
        meta: { userType: UserTypes.CLIENT }
      },
      {
        path: '/area-restrita/cotacao/:id/bb/cancelamento',
        name: 'cliente-cotacao-pagamento-bb-cancel',
        component: ARCCheckoutBBCancel,
        props: true
      }
    ],
  },
];